import { Menu, Transition } from "@headlessui/react";
import { BeakerIcon, ChevronDownIcon } from "@heroicons/react/24/outline";
import { bottom } from "@popperjs/core";
import { Fragment, useRef, useState } from "react";
import { usePopper } from "react-popper";
import { Link } from "react-router-dom";
import Logo from "src/assets/images/logo.png";
import Image from "src/components/elements/Image";
import { classNames } from "src/helpers/classNames";

const DropdownWrapper = ({ data, buttonClass, currentId, buttonLabelClass, buttonIcon, buttonLabel, dropdownContainer, xPlacement = "left", content }) => {
  const popperElRef = useRef(null);
  const [targetElement, setTargetElement] = useState(null);
  const [popperElement, setPopperElement] = useState(null);

  const placements = {
    left: "bottom-start",
    right: "bottom-end",
    "": bottom,
  };

  const { styles, attributes } = usePopper(targetElement, popperElement, {
    placement: placements[xPlacement || ""],
    modifiers: [
      {
        name: "offset",
        options: {
          offset: [0, 0],
        },
      },
    ],
  });

  return (
    <>
      <Menu
        as="div"
        className="relative text-left ">
        <div className="group">
          <Menu.Button
            ref={setTargetElement}
            className={classNames("group flex items-center gap-2 rounded-md px-3 transition-all", buttonClass)}>
            {content ? content : <div className={classNames("text-sm font-medium text-headerTextColor transition-all 2xl:text-base", buttonLabelClass)}>{buttonLabel}</div>}
            {buttonIcon && <ChevronDownIcon className="ml-3 h-5 w-5 flex-shrink-0 text-headerTextColor transition-all group-hover:stroke-headerTextColor group-hover:stroke-2" />}
          </Menu.Button>
        </div>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
          beforeEnter={() => setPopperElement(popperElRef.current)}
          afterLeave={() => setPopperElement(null)}
          ref={popperElRef}
          style={styles.popper}
          {...attributes.popper}>
          <Menu.Items className={classNames("absolute min-w-[200px] rounded-md border border-gray-100 bg-white shadow-md focus:outline-none md:min-w-[300px]", dropdownContainer)}>
            <>
              <div className="grid gap-y-1 pb-3 pt-2">
                {data.map((item) =>
                  item.link ? (
                    <Menu.Item key={item._id}>
                      {({ active }) => (
                        <Link
                          to={item.link}
                          className={classNames("group flex w-full items-center px-3 text-sm transition-all hover:bg-gray-50 hover:text-highlightColor", active ? "bg-carnation-500 text-white" : "text-slate-900")}>
                          {item.name}
                        </Link>
                      )}
                    </Menu.Item>
                  ) : (
                    <Menu.Item key={item._id}>
                      {({ active }) => (
                        <button
                          className={classNames("text flex w-full items-center border border-transparent px-3 py-2 text-left font-medium transition-all hover:bg-gray-100", currentId === item.slug ? "bg-gray-50" : "")}
                          onClick={item.onClick || (() => {})}>
                          <div className={classNames("relative mr-3 rounded-xl border-[4px]", currentId === item.slug ? "border-gray-200" : "border-transparent")}>
                            <div className="h-12 w-12 rounded-md bg-white p-[1px]">
                              <Image
                                src={item.image || Logo}
                                alt={item.name}
                                width={"100%"}
                                height={"100%"}
                                effect={""}
                                classes={"object-contain rounded-md"}
                              />
                            </div>
                          </div>
                          <div className="flex flex-col">
                            <p>{item.name}</p>
                            {item.workspace_type === "JWT_FULL_EMBED" && (
                              <div className="inline-flex items-center gap-x-2 rounded-sm text-sm text-gray-400 opacity-50">
                                <BeakerIcon className="h-4 w-4" />
                                Analytics Builder
                              </div>
                            )}
                          </div>
                        </button>
                      )}
                    </Menu.Item>
                  ),
                )}
              </div>
            </>
          </Menu.Items>
        </Transition>
      </Menu>
    </>
  );
};

export default DropdownWrapper;
